/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SavedPromptsImpl
 *
 */
define([
	'../SavedPromptsAPI',
	'./SavedPromptsAPISpec',
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'underscore'
], (SavedPromptsAPI, SavedPromptsAPISpec, APIFactory, _) => {

	/**
	 * [livewidgt-cleanup] todo: we need to revisit this api and redesign the interface:
	 *  e.g. // the logic for savedPrompts.save() is duplicated in dataQueryExecution.js..
	 */
	/** Class representing a SavedPrompts Implementation */
	class SavedPromptsImpl extends SavedPromptsAPISpec {
		/**
		 * Create a SavedPromptsImpl of SavedPromtsAPI
		 * @param widget the corresponding widget.
		 */
		constructor(widgetModel) {
			super();
			this.widgetModel = widgetModel;
		}

		destroy() {
			this.widgetModel = null;
		}

		getAPI(){
			return APIFactory.createAPI(this, [ SavedPromptsAPI ]);
		}

		save(promptValueSpec) {
			const specToSave = _.pick(promptValueSpec, SavedPromptsImpl.PromptValueSpec_KEYS);

			const savedPrompts = this.widgetModel.get('savedPrompts') || {};
			savedPrompts[specToSave.name] = specToSave;

			return this.reset(savedPrompts);
		}

		reset(promptValueSpec, refresh = false) {
			//silently change the model. an api event will be triggered for this method.
			this.widgetModel['savedPrompts'] = promptValueSpec;
			return refresh;
		}

		getPromptSpec(promptName) {
			const savedPrompts = this.widgetModel.get('savedPrompts');
			if (!savedPrompts || (promptName && !savedPrompts[promptName])) {
				return undefined;
			} else {
				const savedPromptsCopy = JSON.parse(JSON.stringify(savedPrompts));
				return savedPromptsCopy[promptName];
			}
		}


		getPromptSpecList() {
			const savedPrompts =  this.widgetModel.get('savedPrompts') || {};
			const savedPromptsCopy = JSON.parse(JSON.stringify(savedPrompts));
			return _.values(savedPromptsCopy);
		}
	}

	/**
	 * Enum for PROMPTVALUE_KEY.
	 * @readonly
	 * @enum {string}
	 */
	SavedPromptsImpl.PromptValueSpec_KEYS = ['name', 'capabilities', 'dataType', 'values', 'modelFilterItem'];

	return SavedPromptsImpl;
});
